var interfaceTranslations = {
  selectedCountryAriaLabel: "Обрана країна",
  noCountrySelected: "Країну не обрано",
  countryListAriaLabel: "Список країн",
  searchPlaceholder: "Шукати",
  zeroSearchResults: "Результатів не знайдено",
  oneSearchResult: "Знайдено 1 результат",
  multipleSearchResults: "Знайдено ${count} результатів",
  // additional countries (not supported by country-list library)
  ac: "Острів Вознесіння",
  xk: "Косово"
};
export default interfaceTranslations;